import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-100/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
          <span className="text-xl md:text-2xl font-heading font-bold text-primary-500">
            H漫画
          </span>
          <span className="hidden sm:inline text-xs text-foreground-400 bg-background-200/70 px-2 py-0.5 rounded-full">
            在线阅读平台
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          <Link
            to="/"
            className={`px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
              isActive('/')
                ? 'text-primary-500 bg-primary-500/10'
                : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-200'
            }`}
          >
            首页
          </Link>
          <Link
            to="/category/all"
            className={`px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
              location.pathname.startsWith('/category')
                ? 'text-primary-500 bg-primary-500/10'
                : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-200'
            }`}
          >
            分类浏览
          </Link>
          <Link
            to="/about"
            className={`px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
              isActive('/about')
                ? 'text-primary-500 bg-primary-500/10'
                : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-200'
            }`}
          >
            关于我们
          </Link>
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate('/category/all')}
            className="hidden md:flex items-center gap-2 px-4 py-2 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-search-line w-4 h-4 flex items-center justify-center"></i>
            开始阅读
          </button>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-200 hover:bg-background-200 transition-colors cursor-pointer"
          >
            <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-100/98 backdrop-blur-md border-t border-background-200/50">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link
              to="/"
              className={`px-4 py-3 text-sm rounded-lg transition-colors cursor-pointer ${
                isActive('/')
                  ? 'text-primary-500 bg-primary-500/10'
                  : 'text-foreground-300 hover:text-foreground-100'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/all"
              className={`px-4 py-3 text-sm rounded-lg transition-colors cursor-pointer ${
                location.pathname.startsWith('/category')
                  ? 'text-primary-500 bg-primary-500/10'
                  : 'text-foreground-300 hover:text-foreground-100'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`px-4 py-3 text-sm rounded-lg transition-colors cursor-pointer ${
                isActive('/about')
                  ? 'text-primary-500 bg-primary-500/10'
                  : 'text-foreground-300 hover:text-foreground-100'
              }`}
            >
              关于我们
            </Link>
            <button
              onClick={() => {
                setMobileOpen(false);
                navigate('/category/all');
              }}
              className="mt-2 px-4 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              开始阅读
            </button>
          </div>
        </div>
      )}
    </header>
  );
}